/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled('div')`
  width: calc(601px - 253px);
  height: calc(48px + 389px);
  text-align: center;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-left: none;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  background: ${Palette.PrimaryGray._100};
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #f1f5f9;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

export const DragDropContainer = styled('div')`
  border: 1px solid red;
  background: ${Palette.PrimaryGray._200};
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${Palette.PrimaryGray._200};
  cursor: grab;
`;

export const Text = styled.p`
  color: ${Palette.PrimaryGray._500};
  text-align: left;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
